/**
 * Generato automaticamente.
 * framework-cfg-utenti
 */
import { useMutation } from 'react-query';
import type { MutationFunction, UseMutationOptions } from 'react-query';
import { apiClientRequest } from '../../../client/apiClient';
import type { ErrorType } from '../../../client/apiClient';
import type {
  PostOrganigrammaAvviaImportazioneParams,
  SchedulationResult,
} from '.././schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

/**
 * Aggiorna le associazioni utente-ruolo-ufficio dell'utente con l'id passato. Vengono aggiornate/cancellate/inserite solo le associazioni che nel sistema Procedimenti hanno la provenienza dal sistema di importazione dell'organigramma configurato
 * @summary Aggiorna le associazioni utente-ruolo-ufficio dell'utente con l'id passato. Vengono aggiornate/cancellate/inserite solo le associazioni che  nel sistema Procedimenti hanno la provenienza dal sistema di importazione dell'organigramma configurato
 */
export const putOrganigrammaAggiornaAssociazioniEsterneIdUtente = (
  idUtente: string,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<void>(
    {
      url: `/framework-cfg-utenti/organigramma/aggiornaAssociazioniEsterne/${idUtente}`,
      method: 'put',
    },
    options,
  );
};

export const getPutOrganigrammaAggiornaAssociazioniEsterneIdUtenteMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof putOrganigrammaAggiornaAssociazioniEsterneIdUtente>
      >,
      TError,
      { idUtente: string },
      TContext
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof putOrganigrammaAggiornaAssociazioniEsterneIdUtente>
    >,
    TError,
    { idUtente: string },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof putOrganigrammaAggiornaAssociazioniEsterneIdUtente>
      >,
      { idUtente: string }
    > = props => {
      const { idUtente } = props ?? {};

      return putOrganigrammaAggiornaAssociazioniEsterneIdUtente(
        idUtente,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PutOrganigrammaAggiornaAssociazioniEsterneIdUtenteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof putOrganigrammaAggiornaAssociazioniEsterneIdUtente>
    >
  >;

export type PutOrganigrammaAggiornaAssociazioniEsterneIdUtenteMutationError =
  ErrorType<unknown>;

/**
 * @summary Aggiorna le associazioni utente-ruolo-ufficio dell'utente con l'id passato. Vengono aggiornate/cancellate/inserite solo le associazioni che  nel sistema Procedimenti hanno la provenienza dal sistema di importazione dell'organigramma configurato
 */
export const usePutOrganigrammaAggiornaAssociazioniEsterneIdUtente = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof putOrganigrammaAggiornaAssociazioniEsterneIdUtente>
    >,
    TError,
    { idUtente: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPutOrganigrammaAggiornaAssociazioniEsterneIdUtenteMutationOptions(
      options,
    );

  return useMutation(mutationOptions);
};
export const postOrganigrammaAvviaImportazione = (
  params?: PostOrganigrammaAvviaImportazioneParams,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<SchedulationResult>(
    {
      url: `/framework-cfg-utenti/organigramma/avviaImportazione`,
      method: 'post',
      params,
    },
    options,
  );
};

export const getPostOrganigrammaAvviaImportazioneMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postOrganigrammaAvviaImportazione>>,
    TError,
    { params?: PostOrganigrammaAvviaImportazioneParams },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postOrganigrammaAvviaImportazione>>,
  TError,
  { params?: PostOrganigrammaAvviaImportazioneParams },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postOrganigrammaAvviaImportazione>>,
    { params?: PostOrganigrammaAvviaImportazioneParams }
  > = props => {
    const { params } = props ?? {};

    return postOrganigrammaAvviaImportazione(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostOrganigrammaAvviaImportazioneMutationResult = NonNullable<
  Awaited<ReturnType<typeof postOrganigrammaAvviaImportazione>>
>;

export type PostOrganigrammaAvviaImportazioneMutationError = ErrorType<unknown>;

export const usePostOrganigrammaAvviaImportazione = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postOrganigrammaAvviaImportazione>>,
    TError,
    { params?: PostOrganigrammaAvviaImportazioneParams },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostOrganigrammaAvviaImportazioneMutationOptions(options);

  return useMutation(mutationOptions);
};
